import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Employees } from '../../../interfaces/employees';
import { Visitors } from '../../../interfaces/visitors';

@Component({
  selector: 'app-edit-visitor',
  templateUrl: './edit-visitor.component.html',
  styleUrls: ['./edit-visitor.component.css']
})
export class EditVisitorComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal,
  ) {}
  ngOnInit(): void {
    this.getState();
    if (this.visitors != null) {
      this.get(this.visitors);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visitors'].currentValue!=this.visitors) {
      this.get(this.visitors);
    }
  }
  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  visitors: Visitors;
  items:any;
  form1: FormGroup = this.formBuilder.group({
    id:[],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    state_id:[0],
    stores_id: [0],
    date_ing: [],
  });

  get(item: Visitors) {
    this.api.getVisitor(item?.id).subscribe((res)=>{
      let data=res.data as Visitors;
      this.form1.patchValue(res.data);
      this.form1.get('rutview')?.setValue(data?.rut);
    },error=>{
      this.toast.warning(error.error.mistakes,error.error.msg,{enableHtml:true,closeButton:true});
      this.modal.dismissAll();
    });
  }
  getState(){
    this.apiFull.getState().subscribe((res)=>{
      this.items=res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    this.api.updateVisitors(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Visitantes');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg,{enableHtml:true,closeButton:true});
      }
    );
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
